import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref, watch, computed, useAttrs } from 'vue'
import { useStore } from 'vuex'

interface DialogProps {
  component: any
  uid: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'modal',
  props: {
    component: {},
    uid: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const store = useStore()
const show = ref(false)
const compRef = ref()
const curRef = computed(() => compRef.value)

const modal: any = ref(null)
const attrs: any = ref({})
const setState = (data: any) => {
  if (data[props.uid]) {
    // current传递给组件的参数
    const current = data[props.uid]
    attrs.value = current
    show.value = current.show
    if (current.modal) {
      // current.modal传递给dialog参数
      modal.value = current.modal
    }
  }
}

const modalAttrs = computed(() => {
  // modal的title取attrs的数据
  // tipModal取slot的数据（fix title优先级高于slot）
  if (modal.value) {
    const { title, ...rest } = modal.value
    return { ...useAttrs(), ...rest }
  }
  return useAttrs()
})

const handleClose = () => {
  if (props.uid) {
    store.commit('modal/close', { uid: props.uid })
  }
}

watch(
  () => store.state.modal.data,
  setState,
  { deep: true }
)

__expose({ curRef })

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, _mergeProps({
    open: show.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    "destroy-on-close": "",
    width: "600px",
    "mask-closable": false,
    afterClose: handleClose
  }, modalAttrs.value), {
    title: _withCtx(() => [
      _renderSlot(_ctx.$slots, "title")
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component.default), _mergeProps({
          ref_key: "compRef",
          ref: compRef
        }, attrs.value), null, 16))
      ])
    ]),
    _: 3
  }, 16, ["open"]))
}
}

})